<template>
  <!-- 待办 -->
  <div class="ccui-home-index">
    <div class="ccui-app-container">
      <div
        class="ccui-advanced-search-wrapper ccui-clearfix"
        ref="advancedSearchWrapper"
      >
        <!-- <div class="ccui-tab-wrapper" style="line: height 20px">
          <span style="color: #4a4a4a; font-size: 14px; font-weight: 400"
            >个人管理平台 - 待办<span style="color: #0089ef">{{
              `(${pageTotal || 0})`
            }}</span>
          </span>
          <span @click="oldLink" class="old-link">
              供应链系统（旧版）
            </span>
        </div> -->
      </div>
      <div style="position: relative; display: flex">
        <el-table
          :key="1"
          :data="tableData"
          :span-method="objectSpanMethod"
          border
          style="width: 40%; margin-top: 10px"
          :cellStyle="cellStyle"
          @cell-click="cellClick"
          max-height="9999"
        >
          <el-table-column prop="id" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="taskType" label="所属菜单" width="120">
          </el-table-column>
          <el-table-column prop="taskName" label="任务名称" width="160">
          </el-table-column>
          <el-table-column prop="messagesNums" label="消息数量" width="100">
            <template slot-scope="scope">
              <span
                style="font-weight: 500"
                :class="{ messagesNums: Number(scope.row.messagesNums) > 0 }"
                v-if="scope.row.messagesNums !== ''"
                >{{ scope.row.messagesNums }}条</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="width: 40px"></div>
        <el-table
          :key="2"
          :data="tableData1"
          :span-method="objectSpanMethod"
          border
          style="width: 40%; margin-top: 10px"
          :cellStyle="cellStyle"
          @cell-click="cellClick"
          max-height="9999"
        >
          <el-table-column prop="id" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="taskType" label="所属菜单" width="120">
          </el-table-column>
          <el-table-column prop="taskName" label="任务名称" width="160">
          </el-table-column>
          <el-table-column prop="messagesNums" label="消息数量" width="100">
            <template slot-scope="scope">
              <span
                style="font-weight: 500"
                :class="{ messagesNums: Number(scope.row.messagesNums) > 0 }"
                v-if="scope.row.messagesNums !== ''"
                >{{ scope.row.messagesNums }}条</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserInfo } from "@/config/api/login";
import { queryProcessReminder, readProcessReminder } from "./api.js";
import { deepClone } from "@/basa/utils/";
let tableData = [
  {
    id: "1",
    taskType: "客商管理",
    taskName: "客户信息待审批",
    messagesNums: 0,
    key: "custTodoNum",
    num: 9,
    index: 0,
    url: "/customerAndBusiness/customerInfoApproval/pending"
  },
  {
    id: "1",
    taskType: "客商管理",
    taskName: "客户信息审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1701", //业务类型
    messagesNums: 0,
    key: "custPassNum",
    num: 9,
    index: 0,
    url: "/customerAndBusiness/customerInfo/pass"
  },
  {
    id: "1",
    taskType: "客商管理",
    taskName: "客户信息审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1701", //业务类型
    messagesNums: 0,
    key: "custReturnNum",
    num: 9,
    index: 0,
    url: "/customerAndBusiness/customerInfo/return"
  },
  {
    id: "1",
    taskType: "客商管理",
    taskName: "市场信息待审批",
    messagesNums: 0,
    key: "mktTodoNum",
    num: 9,
    index: 0,
    url: "/customerAndBusiness/marketInfoApproval/pending"
  },
  {
    id: "1",
    taskType: "客商管理",
    taskName: "市场信息审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1703", //业务类型
    messagesNums: 0,
    key: "mktPassNum",
    num: 9,
    index: 0,
    url: "/customerAndBusiness/marketInfo/pass"
  },
  {
    id: "1",
    taskType: "客商管理",
    taskName: "市场信息审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1703", //业务类型
    messagesNums: 0,
    key: "mktReturnNum",
    num: 9,
    index: 0,
    url: "/customerAndBusiness/marketInfo/return"
  },
  {
    id: "1",
    taskType: "客商管理",
    taskName: "供应/分包商待审批",
    messagesNums: 0,
    key: "supTodoNum",
    num: 9,
    index: 0,
    url: "/customerAndBusiness/supplierAndSubcontractorApproval/pending"
  },
  {
    id: "1",
    taskType: "客商管理",
    taskName: "供应/分包商审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1705", //业务类型
    messagesNums: 0,
    key: "supPassNum",
    num: 9,
    index: 0,
    url: "/customerAndBusiness/supplierAndSubcontractor/pass"
  },
  {
    id: "1",
    taskType: "客商管理",
    taskName: "供应/分包商审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1705", //业务类型
    messagesNums: 0,
    key: "supReturnNum",
    num: 9,
    index: 0,
    url: "/customerAndBusiness/supplierAndSubcontractor/return"
  },

  {
    id: "2",
    taskType: "生产管理",
    taskName: "经营项目待审批",
    messagesNums: 0,
    key: "mgmtTodoNum",
    num: 12,
    index: 9,
    url: "/productionManage/operationProjectApproval/pending"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "经营项目审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1801", //业务类型
    messagesNums: 0,
    key: "mgmtPassNum",
    num: 12,
    index: 9,
    url: "/productionManage/operationProject/pass"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "经营项目审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1801", //业务类型
    messagesNums: 0,
    key: "mgmtReturnNum",
    num: 12,
    index: 9,
    url: "/productionManage/operationProject/return"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "生产项目待审批",
    messagesNums: 0,
    key: "proTodoNum",
    num: 12,
    index: 9,
    url: "/productionManage/productionProjectApproval/pending"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "生产项目审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1803", //业务类型
    messagesNums: 0,
    key: "proPassNum",
    num: 12,
    index: 9,
    query: { isActive: "pass" },
    url: "/productionManage/productionProject/taskDivide"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "生产项目审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1803", //业务类型
    messagesNums: 0,
    key: "proReturnNum",
    num: 12,
    index: 9,
    query: { isActive: "return" },
    url: "/productionManage/productionProject/taskDivide"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "通用收入确认待审批",
    messagesNums: 0,
    key: "incomeTodoNum",
    num: 12,
    index: 9,
    url: "/productionManage/incomeConfirmApproval/pending"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "通用收入确认审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1807", //业务类型
    messagesNums: 0,
    key: "incomePassNum",
    num: 12,
    index: 9,
    url: "/productionManage/incomeConfirm/pass"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "通用收入确认审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1807", //业务类型
    messagesNums: 0,
    key: "incomeReturnNum",
    num: 12,
    index: 9,
    url: "/productionManage/incomeConfirm/return"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "项目预算待审批",
    messagesNums: 0,
    key: "budgetTodoNum",
    num: 12,
    index: 9,
    url: "/productionManage/projectBudgetAddApproval/pending"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "项目预算审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1805", //业务类型
    messagesNums: 0,
    key: "budgetPassNum",
    num: 12,
    index: 9,
    url: "/productionManage/projectBudgetAdd/pass"
  },
  {
    id: "2",
    taskType: "生产管理",
    taskName: "项目预算审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1805", //业务类型
    messagesNums: 0,
    key: "budgetReturnNum",
    num: 12,
    index: 9,
    url: "/productionManage/projectBudgetAdd/return"
  },
  {
    id: "3",
    taskType: "销售管理",
    taskName: "生产项目类主合同待审批",
    messagesNums: 0,
    key: "concTodoNum",
    num: 6,
    index: 21,
    url: "/contractProject/salesContractApproval/pending"
  },
  {
    id: "3",
    taskType: "销售管理",
    taskName: "生产项目类主合同审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1901", //业务类型
    messagesNums: 0,
    key: "conctPassNum",
    num: 6,
    index: 21,
    url: "/contractProject/salesContractInput/pass"
  },
  {
    id: "3",
    taskType: "销售管理",
    taskName: "生产项目类主合同审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1901", //业务类型
    messagesNums: 0,
    key: "concReturnNum",
    num: 6,
    index: 21,
    url: "/contractProject/salesContractInput/return"
  },
  {
    id: "3",
    taskType: "销售管理",
    taskName: "其他服务类主合同待审批",
    messagesNums: 0,
    key: "otherConcTodoNum",
    num: 6,
    index: 21,
    url: "/contractProject/otherContractApproval/pending"
  },
  {
    id: "3",
    taskType: "销售管理",
    taskName: "其他服务类主合同审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1909", //业务类型
    messagesNums: 0,
    key: "otherConcPassNum",
    num: 6,
    index: 21,
    url: "/contractProject/otherContractInput/pass"
  },
  {
    id: "3",
    taskType: "销售管理",
    taskName: "其他服务类主合同审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1909", //业务类型
    messagesNums: 0,
    key: "otherConcReturnNum",
    num: 6,
    index: 21,
    url: "/contractProject/otherContractInput/return"
  }
];

let tableData1 = [
  {
    id: "4",
    taskType: "采购管理",
    taskName: "生产项目类采购合同待审批",
    messagesNums: 0,
    key: "purConcTodoNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/purchaseContractApproval/pending"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "生产项目类采购合同审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1905", //业务类型
    messagesNums: 0,
    key: "purConcPassNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/purchaseContractInput/pass"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "生产项目类采购合同审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1905", //业务类型
    messagesNums: 0,
    key: "purConcReturnNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/purchaseContractInput/return"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "其他服务类采购合同待审批",
    messagesNums: 0,
    key: "otherPurConcTodoNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/otherContractApproval/pending"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "其他服务类采购合同审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y1913", //业务类型
    messagesNums: 0,
    key: "otherPurConcPassNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/otherPurchaseContractInput/pass"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "其他服务类采购合同审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y1913", //业务类型
    messagesNums: 0,
    key: "otherPurConcReturnNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/otherPurchaseContractInput/return"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "采购进度确认待审批",
    messagesNums: 0,
    key: "purSchedTodoNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/purchaseProgressApproval/pending"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "采购进度确认审批通过",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y2001", //业务类型
    messagesNums: 0,
    key: "purSchedPassNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/purchaseProgress/pass"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "采购进度确认审批退回",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y2001", //业务类型
    messagesNums: 0,
    key: "purSchedReturnNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/purchaseProgress/return"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "采购分包结算待审批",
    messagesNums: 0,
    key: "subPkgTodoNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/subcontractSuanApproval/pending"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "采购分包结算审批通过",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y2002", //业务类型
    messagesNums: 0,
    key: "subPkgPassNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/subcontractSuan/pass"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "采购分包结算审批退回",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y2002", //业务类型
    messagesNums: 0,
    key: "subPkgReturnNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/subcontractSuan/return"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "采购分包付款待审批",
    messagesNums: 0,
    key: "payTodoNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/purchaseSubcontractPayApproval/pending"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "采购分包付款审批通过",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y2003", //业务类型
    messagesNums: 0,
    key: "payPassNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/purchaseSubcontractPay/pass"
  },
  {
    id: "4",
    taskType: "采购管理",
    taskName: "采购分包付款审批退回",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y2003", //业务类型
    messagesNums: 0,
    key: "payReturnNum",
    num: 15,
    index: 0,
    url: "/contractPurchase/purchaseSubcontractPay/return"
  },
  {
    id: "5",
    taskType: "财务管理",
    taskName: "发票申请待审批",
    messagesNums: 0,
    key: "invoiceTodoNum",
    num: 9,
    index: 15,
    url: "/financeManage/invoiceApplyApproval/pending"
  },
  {
    id: "5",
    taskType: "财务管理",
    taskName: "发票申请通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y2101", //业务类型
    messagesNums: 0,
    key: "invoicePassNum",
    num: 9,
    index: 15,
    url: "/financeManage/invoiceApply/pass"
  },
  {
    id: "5",
    taskType: "财务管理",
    taskName: "发票申请审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y2101", //业务类型
    messagesNums: 0,
    key: "invoiceReturnNum",
    num: 9,
    index: 15,
    url: "/financeManage/invoiceApply/return"
  },
  {
    id: "5",
    taskType: "财务管理",
    taskName: "资金计划待审批",
    messagesNums: 0,
    key: "fundPlanTodoNum",
    num: 9,
    index: 15,
    url: "/financeManage/fundingPlanApproval/pending"
  },
  {
    id: "5",
    taskType: "财务管理",
    taskName: "资金计划审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y2103", //业务类型
    messagesNums: 0,
    key: "fundPlanPassNum",
    num: 9,
    index: 15,
    url: "/financeManage/fundingPlan/pass"
  },
  {
    id: "5",
    taskType: "财务管理",
    taskName: "资金计划审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y2103", //业务类型
    messagesNums: 0,
    key: "fundPlanReturnNum",
    num: 9,
    index: 15,
    url: "/financeManage/fundingPlan/return"
  },
  {
    id: "5",
    taskType: "财务管理",
    taskName: "暂估成本计提单待审批",
    messagesNums: 0,
    key: "costCtrlTodoNum",
    num: 9,
    index: 15,
    url: "/financeManage/costMgmtAddApproval/pending"
  },
  {
    id: "5",
    taskType: "财务管理",
    taskName: "暂估成本计提单审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y2102", //业务类型
    messagesNums: 0,
    key: "costCtrlPassNum",
    num: 9,
    index: 15,
    url: "/financeManage/costMgmtAdd/pass"
  },
  {
    id: "5",
    taskType: "财务管理",
    taskName: "暂估成本计提单审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y2102", //业务类型
    messagesNums: 0,
    key: "costCtrlReturnNum",
    num: 9,
    index: 15,
    url: "/financeManage/costMgmtAdd/return"
  },
  {
    id: "6",
    taskType: "科研管理",
    taskName: "科研项目新增待审批",
    messagesNums: 0,
    key: "sciProjectTodoNum",
    num: 3,
    index: 24,
    url: "/scientificResearch/projectApproval/pending"
  },
  {
    id: "6",
    taskType: "科研管理",
    taskName: "科研项目新增审批通过提醒",
    approvalResult: 3, //3-审批通过，4-审批退回
    businessType: "Y2201", //业务类型
    messagesNums: 0,
    key: "sciProjectPassNum",
    num: 3,
    index: 24,
    url: "/scientificResearch/projectAdd/pass"
  },
  {
    id: "6",
    taskType: "科研管理",
    taskName: "科研项目新增审批退回提醒",
    approvalResult: 4, //3-审批通过，4-审批退回
    businessType: "Y2201", //业务类型
    messagesNums: 0,
    key: "sciProjectReturnNum",
    num: 3,
    index: 24,
    url: "scientificResearch/projectAdd/return"
  }
];
export default {
  name: "myTodoList",
  data() {
    return {
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL),
      pageTotal: 0,
      tableName: "myTodoList",
      tableData: deepClone(tableData),
      tableData1: deepClone(tableData1),
      appList: [], //公共应用
      openId: ""
    };
  },

  activated() {
    this.tableData = deepClone(tableData);
    this.tableData1 = deepClone(tableData1);
    this.getData();
  },
  methods: {
    oldLink() {
      if (this.baseUrl.indexOf("dev01") != -1) {
        window.location.href = "http://empm.ccccltd.cn/";
      } else if (this.baseUrl.indexOf("test01") != -1) {
        window.location.href = "http://empm.ccccltd.cn/";
      } else if (this.baseUrl.indexOf("uat01") != -1) {
        window.location.href = "http://empm.ccccltd.cn/";
      } else {
        window.location.href = "http://empm.ccccltd.cn/";
      }
    },
    getData() {
      getUserInfo({ initLoading: true }).then(res => {
        if (res.data.code === "0") {
          let openId = res.data.data.userInfo.openId;
          this.openId = openId;
          this.appList = res.data.data.mOrganizations[0].appList;
          // this.sscPurchaseAgenda(openId);
          this.getDa(openId);
        }
      });
    },
    getDa(openId) {
      queryProcessReminder({ openId }).then(da => {
        this.pageTotal = 0;
        const item = da.data.data;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            this.tableData.forEach(e => {
              if (e.key == key) {
                e.messagesNums = item[key] ? item[key] : e.messagesNums;
                if (item[key]) {
                  this.pageTotal += item[key];
                }
              }
            });

            this.tableData1.forEach(e => {
              if (e.key == key) {
                e.messagesNums = item[key] ? item[key] : e.messagesNums;
              }
            });
          }
        }
        // this.pageTotal = res[0].data.data.totalNum+res[1].data.data.totalNum+res[2].data.data.totalNum+res[3].data.data.totalNum;
        this.$forceUpdate();
      });
    },
    // sscPurchaseAgenda(openId) {
    //   Promise.all([
    //     querySscPurchaseAgendaPart1({ openId: openId, purSupFlag: "pur" }),
    //     querySscPurchaseAgendaPart2({ openId: openId, purSupFlag: "pur" }),
    //     querySscPurchaseAgendaPart3({ openId: openId, purSupFlag: "pur" }),
    //     querySscPurchaseAgendaPart4({ openId: openId, purSupFlag: "pur" }),
    //   ]).then((res) => {
    //     // let data = Object.assign({}, res[0].data.data, res[1].data.data, res[2].data.data,res[3].data.data);
    //     this.pageTotal = 0;
    //     res.forEach((item) => {
    //       item = item.data.data;
    //       for (const key in item) {
    //         if (Object.hasOwnProperty.call(item, key)) {
    //           this.tableData.forEach((e) => {
    //             if (e.key == key) {
    //               e.messagesNums = item[key] ? item[key] : e.messagesNums;
    //               if (item[key]) {
    //                 this.pageTotal += item[key];
    //               }
    //             }
    //           });

    //           this.tableData1.forEach((e) => {
    //             if (e.key == key) {
    //               e.messagesNums = item[key] ? item[key] : e.messagesNums;
    //             }
    //           });
    //         }
    //       }
    //     });
    //     // this.pageTotal = res[0].data.data.totalNum+res[1].data.data.totalNum+res[2].data.data.totalNum+res[3].data.data.totalNum;
    //     this.$forceUpdate();
    //   });
    //   // sscPurchaseAgenda({ openId: openId, purSupFlag: "pur" })
    //   //   .then(res => {
    //   //     if (res.data.code === "0") {
    //   //       let data = res.data.data;
    //   //       for (const key in data) {
    //   //         if (Object.hasOwnProperty.call(data, key)) {
    //   //           this.tableData.forEach(e => {
    //   //             if (e.key == key) {
    //   //               e.messagesNums = data[key];
    //   //             }
    //   //           });
    //   //
    //   //           this.tableData1.forEach(e => {
    //   //             if (e.key == key) {
    //   //               e.messagesNums = data[key];
    //   //             }
    //   //           });
    //   //         }
    //   //       }
    //   //       this.pageTotal = res.data.data.totalNum;
    //   //       this.$forceUpdate();
    //   //     }
    //   //   })
    //   //   .catch(error => {});
    // },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex === row.index) {
          return {
            rowspan: row.num,
            colspan: 1
          };
        } else if (rowIndex > row.index && rowIndex <= row.index + row.num) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      if (column.property === "messagesNums") {
        if (row.messagesNums > 0) {
          return {
            color: "#eb090c",
            cursor: "pointer"
          };
        }
      }
      if (column.property === "id") {
        return {
          background: "#F8F8F8"
        };
      }
    },
    async cellClick(row, column, cell, e) {
      if (column.property === "messagesNums") {
        if (row.messagesNums > 0 && row.url) {
          if (row.approvalResult) {
            readProcessReminder({
              businessType: row.businessType,
              approvalResult: row.approvalResult,
              openId: this.openId
            }).then(re => {
              this.$router.push({
                path: row.url,
                query: {
                  ...row.query,
                  t: new Date().getTime()
                  // a: this.$route_query.a,
                }
              });
            });
          } else {
            this.$router.push({
              path: row.url,
              query: {
                ...row.query,
                t: new Date().getTime()
                // a: this.$route_query.a,
              }
            });
          }
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.old-link {
  color: rgb(74, 74, 74);
  font-size: 14px;
  font-weight: 400;
  margin-left: 20px;
}
.old-link:hover {
  color: rgb(235, 9, 12);
  cursor: pointer;
  text-decoration: underline;
}
/deep/.el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
.ccui-app-container {
  padding-top: 10px;
}
/deep/ .el-table {
  .el-table__header {
    tr {
      th:not(:nth-child(4)) {
        height: 36px;
        border-right: 1px solid #edf2fc;
      }
      th:first-child {
        background: rgb(248, 248, 248) !important;
      }
    }
  }
  tr {
    td {
      border-right: 1px solid #edf2fc;
      font-size: 13px;
      //font-family: PingFangSC-Regular, PingFang SC;
    }
  }
  .cell {
    line-height: 28px !important;
    height: 28px;
  }
  .messagesNums {
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
